import { call, put, takeLatest } from "redux-saga/effects";
import request from "../../api/request";
import requestAxios from "../../api/requestAxios";

function* getAutomaticAssignmentRules(payload) {
  try {
    yield put({
      type: "FETCHING_ALL_AUTOMATIC_ASSIGMENT_RULES",
    });

    yield put({
      type: "SHOW_LOADING",
    });

    const headers = {
      method: "GET",
      headers: new Headers({
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      }),
    };

    let requestURL = `${process.env.REACT_APP_API_URL}/api/v1/automaticAssigner/assigmentRules?page=${
      payload.value.page
    }&offset=${
      payload.value.offset
    }&search=${payload.value.search}`;
    const response = yield call(request, requestURL, headers);

    yield put({
      type: "HIDE_LOADING",
    });

    yield put({
      type: "ALL_AUTOMATIC_ASSIGMENT_RULES_SUCCESS",
      value: response,
    });
  } catch (error) {
    yield put({
      type: "HIDE_LOADING",
    });
    yield put({
      type: "SHOW_ALERT",
      value: {
        type: "danger",
        title: "Failed load",
        message: "Failed load Addresses",
      },
    });
    yield put({
      type: "ALL_AUTOMATIC_ASSIGMENT_RULES_ERROR",
    });
  }
}

function* getAllAddressesToAutomaticAssigment(payload) {
  
  try {
    yield put({
      type: "FETCHING_ALL_ADDRESSES_TO_AUTOMATIC_ASSIGMENT",
    });

    yield put({
      type: "SHOW_LOADING",
    });

    const headers = {
      method: "GET",
      headers: new Headers({
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      }),
    };

    let requestURL = `${process.env.REACT_APP_API_URL}/api/v1/automaticAssigner?page=${
      payload.value.page
    }&offset=${payload.value.offset}${
      payload.value.isActive ? "&isActive=" + payload.value.isActive : ""
    }&search=${payload.value.search}`;
    if (payload.value.from) {
      requestURL = requestURL + `&from=${payload.value.from}`;
    }
    if (payload.value.to) {
      requestURL = requestURL + `&to=${payload.value.to}`;
    }
    if (payload.value.idState && payload.value.idState != "") {
      requestURL = requestURL + `&idState=${payload.value.idState}`;
    }
    const response = yield call(request, requestURL, headers);

    yield put({
      type: "HIDE_LOADING",
    });

    yield put({
      type: "ALL_ADDRESSES_TO_AUTOMATIC_ASSIGMENT_SUCCESS",
      value: response,
    });
  } catch (error) {
    yield put({
      type: "HIDE_LOADING",
    });
    yield put({
      type: "SHOW_ALERT",
      value: {
        type: "danger",
        title: "Failed load",
        message: "Failed load Addresses",
      },
    });
    yield put({
      type: "ALL_ADDRESSES_TO_AUTOMATIC_ASSIGMENT_ERROR",
    });
  }
}

function* getAllFailedAddressesToAutomaticAssigment(payload) {
  
  try {
    yield put({
      type: "FETCHING_ALL_FAILED_ADDRESSES_TO_AUTOMATIC_ASSIGMENT",
    });

    yield put({
      type: "SHOW_LOADING",
    });

    const headers = {
      method: "GET",
      headers: new Headers({
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      }),
    };

    let requestURL = `${process.env.REACT_APP_API_URL}/api/v1/automaticAssigner/failedAssignments?page=${
      payload.value.page
    }&offset=${payload.value.offset}${
      payload.value.isActive ? "&isActive=" + payload.value.isActive : ""
    }&search=${payload.value.search}`;
    if (payload.value.from) {
      requestURL = requestURL + `&from=${payload.value.from}`;
    }
    if (payload.value.to) {
      requestURL = requestURL + `&to=${payload.value.to}`;
    }
    if (payload.value.idState && payload.value.idState != "") {
      requestURL = requestURL + `&idState=${payload.value.idState}`;
    }
    const response = yield call(request, requestURL, headers);

    yield put({
      type: "HIDE_LOADING",
    });

    yield put({
      type: "ALL_FAILED_ADDRESSES_TO_AUTOMATIC_ASSIGMENT_SUCCESS",
      value: response,
    });
  } catch (error) {
    yield put({
      type: "HIDE_LOADING",
    });
    yield put({
      type: "SHOW_ALERT",
      value: {
        type: "danger",
        title: "Failed load",
        message: "Failed load Addresses",
      },
    });
    yield put({
      type: "ALL_FAILED_ADDRESSES_TO_AUTOMATIC_ASSIGMENT_ERROR",
    });
  }
}

function* getAllAddressesToAutomaticAssigmentSocket(payload) {
  
  try {
    yield put({
      type: "FETCHING_ALL_ADDRESSES_TO_AUTOMATIC_ASSIGMENT",
    });

    const headers = {
      method: "GET",
      headers: new Headers({
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      }),
    };

    let requestURL = `${process.env.REACT_APP_API_URL}/api/v1/automaticAssigner?page=${
      payload.value.page
    }&offset=${payload.value.offset}${
      payload.value.isActive ? "&isActive=" + payload.value.isActive : ""
    }&search=${payload.value.search}`;
    if (payload.value.from) {
      requestURL = requestURL + `&from=${payload.value.from}`;
    }
    if (payload.value.to) {
      requestURL = requestURL + `&to=${payload.value.to}`;
    }
    if (payload.value.idState && payload.value.idState != "") {
      requestURL = requestURL + `&idState=${payload.value.idState}`;
    }
    const response = yield call(request, requestURL, headers);

    yield put({
      type: "ALL_ADDRESSES_TO_AUTOMATIC_ASSIGMENT_SUCCESS",
      value: response,
    });
  } catch (error) {
    yield put({
      type: "SHOW_ALERT",
      value: {
        type: "danger",
        title: "Failed load",
        message: "Failed load Addresses",
      },
    });
    yield put({
      type: "ALL_ADDRESSES_TO_AUTOMATIC_ASSIGMENT_ERROR",
    });
  }
}

function* getCountAllAddressesToAutomaticAssigment(payload) {
  
  try {
    yield put({
      type: "FETCHING_ALL_COUNT_ADDRESSES_TO_AUTOMATIC_ASSIGMENT",
    });

    yield put({
      type: "SHOW_LOADING",
    });

    const headers = {
      method: "GET",
      headers: new Headers({
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      }),
    };

    let requestURL = `${process.env.REACT_APP_API_URL}/api/v1/automaticAssigner/counts`;

    const response = yield call(request, requestURL, headers);

    yield put({
      type: "HIDE_LOADING",
    });

    yield put({
      type: "COUNT_ALL_ADDRESSES_TO_AUTOMATIC_ASSIGMENT_SUCCESS",
      value: response,
    });
  } catch (error) {
    yield put({
      type: "HIDE_LOADING",
    });
    yield put({
      type: "SHOW_ALERT",
      value: {
        type: "danger",
        title: "Failed load",
        message: "Failed load Addresses",
      },
    });
    yield put({
      type: "COUNT_ALL_ADDRESSES_TO_AUTOMATIC_ASSIGMENT_ERROR",
    });
  }
}

function* getDetailToProgressBarToAutomaticAssigment() {
  try {
    yield put({
      type: "FETCHING_DETAIL_PROGRESS_BAR_TO_AUTOMATIC_ASSIGMENT",
    });

    const headers = {
      method: "GET",
      headers: new Headers({
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      }),
    };

    let requestURL = `${process.env.REACT_APP_API_URL}/api/v1/automaticAssigner/progressBar`;

    const response = yield call(request, requestURL, headers);

    yield put({
      type: "DETAIL_PROGRESS_BAR_TO_AUTOMATIC_ASSIGMENT_SUCCESS",
      value: response,
    });
  } catch (error) {
    yield put({
      type: "DETAIL_PROGRESS_BAR_TO_AUTOMATIC_ASSIGMENT_ERROR",
    });
  }
}

function* getCountAllAddressesToAutomaticAssigmentSocket(payload) {
  
  try {
    yield put({
      type: "FETCHING_ALL_COUNT_ADDRESSES_TO_AUTOMATIC_ASSIGMENT",
    });

    const headers = {
      method: "GET",
      headers: new Headers({
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      }),
    };

    let requestURL = `${process.env.REACT_APP_API_URL}/api/v1/automaticAssigner/counts`;

    const response = yield call(request, requestURL, headers);

    yield put({
      type: "COUNT_ALL_ADDRESSES_TO_AUTOMATIC_ASSIGMENT_SUCCESS",
      value: response,
    });
  } catch (error) {
    yield put({
      type: "SHOW_ALERT",
      value: {
        type: "danger",
        title: "Failed load",
        message: "Failed load Addresses",
      },
    });
    yield put({
      type: "COUNT_ALL_ADDRESSES_TO_AUTOMATIC_ASSIGMENT_ERROR",
    });
  }
}

function* getAddressesPreviousWeekPieChart(payload) {
  
  try {
    yield put({
      type: "ADDRESS_PREVIOUS_WEEK_PIE_CHART_REQUESTING",
    });

    yield put({
      type: "SHOW_LOADING",
    });

    const headers = {
      method: "GET",
      headers: new Headers({
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      }),
    };

    let requestURL = `${process.env.REACT_APP_API_URL}/api/v1/automaticAssigner/addressesPreviousWeek`;

    const response = yield call(request, requestURL, headers);

    yield put({
      type: "ADDRESS_PREVIOUS_WEEK_PIE_CHART_SUCCESS",
      value: response,
    });
  } catch (error) {
    yield put({
      type: "HIDE_LOADING",
    });
    yield put({
      type: "SHOW_ALERT",
      value: {
        type: "danger",
        title: "Failed load",
        message: "Failed load Addresses",
      },
    });
    yield put({
      type: "ADDRESS_PREVIOUS_WEEK_PIE_CHART_ERROR",
    });
  }
}

function* getCountAssignedAdressesByMonth(payload) {
  
  try {
    yield put({
      type: "COUNT_ASSIGNED_ADDRESSES_BY_MONTH_REQUESTING",
    });

    yield put({
      type: "SHOW_LOADING",
    });

    const headers = {
      method: "GET",
      headers: new Headers({
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      }),
    };

    let requestURL = `${process.env.REACT_APP_API_URL}/api/v1/automaticAssigner/addressesByMonth?`;
    
    if (payload.value.from) {
      requestURL = requestURL + `from=${payload.value.from}`;
    }
    if (payload.value.to) {
      requestURL = requestURL + `&to=${payload.value.to}`;
    }

    const response = yield call(request, requestURL, headers);

    yield put({
      type: "COUNT_ASSIGNED_ADDRESSES_BY_MONTH_SUCCESS",
      value: response,
    });
  } catch (error) {
    yield put({
      type: "HIDE_LOADING",
    });
    yield put({
      type: "SHOW_ALERT",
      value: {
        type: "danger",
        title: "Failed load",
        message: "Failed load Addresses",
      },
    });
    yield put({
      type: "COUNT_ASSIGNED_ADDRESSES_BY_MONTH_ERROR",
    });
  }
}

function* downloadAllAutomaticAssigment(action) {  
  try {
    yield put({ type: "DOWNLOAD_AUTOMATIC_ASIGMENT_CSV_REQUESTING" });
    yield put({ type: "SHOW_LOADING" });

    const requestURL = `${process.env.REACT_APP_API_URL}/api/v1/automaticAssigner/csv`;

    const options = {
      method: "POST",
      headers: new Headers({
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify({
        from: action.value.from,
        to: action.value.to,
        idState: action.value.idState, 
        search: action.value.search
      }),
    };

    const response = yield call(fetch, requestURL, options);
    if (response.ok) {
      const blob = yield call([response, response.blob]);
      const url = window.URL.createObjectURL(blob);

      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const fileName = `${year}_${month}_${day}_AUTOMATIC_ASSIGMENT.csv`;

      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);

      yield put({ type: "DOWNLOAD_AUTOMATIC_ASIGMENT_CSV_SUCCESS" });
    } else {
      yield put({ type: "DOWNLOAD_AUTOMATIC_ASIGMENT_CSV_ERROR", value: { message: "Error downloading CSV" } });
    }
    
    yield put({ type: "HIDE_LOADING" });
  } catch (error) {
    yield put({ type: "HIDE_LOADING" });
    yield put({ type: "DOWNLOAD_AUTOMATIC_ASIGMENT_CSV_ERROR", value: { message: error.message } });
  }
}

function* downloadFailedAutomaticAssigment(action) {  
  try {
    yield put({ type: "DOWNLOAD_FAILED_AUTOMATIC_ASIGMENT_CSV_REQUESTING" });
    yield put({ type: "SHOW_LOADING" });

    const requestURL = `${process.env.REACT_APP_API_URL}/api/v1/automaticAssigner/failedOrders/csv`;

    const options = {
      method: "POST",
      headers: new Headers({
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify({
        from: action.value.from,
        to: action.value.to,
        idState: action.value.idState, 
        search: action.value.search
      }),
    };

    const response = yield call(fetch, requestURL, options);
    if (response.ok) {
      const blob = yield call([response, response.blob]);
      const url = window.URL.createObjectURL(blob);

      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const fileName = `${year}_${month}_${day}_AUTOMATIC_ASSIGMENT_FAILED_ORDERS.csv`;

      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);

      yield put({ type: "DOWNLOAD_FAILED_AUTOMATIC_ASIGMENT_CSV_SUCCESS" });
    } else {
      yield put({ type: "DOWNLOAD_FAILED_AUTOMATIC_ASIGMENT_CSV_ERROR", value: { message: "Error downloading CSV" } });
    }
    
    yield put({ type: "HIDE_LOADING" });
  } catch (error) {
    yield put({ type: "HIDE_LOADING" });
    yield put({ type: "DOWNLOAD_FAILED_AUTOMATIC_ASIGMENT_CSV_ERROR", value: { message: error.message } });
  }
}

function* switchBotStateAutomaticAssigment(payload) {  
  try {
    yield put({ type: "SWITCH_BOT_AUTOMATIC_ASIGMENT_REQUESTING" });

    yield put({ type: "SHOW_LOADING" });

    const requestURL = `${process.env.REACT_APP_API_URL}/api/v1/automaticAssigner/switchBot`;

    const headers = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        switchTo: payload.value.switchTo,
      }),
    };

    const response = yield call(request, requestURL, headers);

    yield put({
      type: "HIDE_LOADING",
    });

    yield put({
      type: "SHOW_ALERT",
      value: {
        type: "success",
        title: "Cambio de estado exitoso",
        message: "Actualización exitosa",
      },
    });

    yield put({
      type: "SWITCH_BOT_AUTOMATIC_ASIGMENT_SUCCESS",
      value: {
        ...response,
        redirectTo: payload.value.switchTo === "start" ? "/assigner" : ""
      }
    });
  } catch (error) {
    yield put({
      type: "SHOW_ALERT",
      value: {
        type: "danger",
        title: "Error al guardar",
        message: "Error al realizar el cambio de estado",
      },
    });
    yield put({
      type: "HIDE_LOADING",
    });
    yield put({
      type: "SWITCH_BOT_AUTOMATIC_ASIGMENT_ERROR",
    });
  }
}

function* getRecordStatusAutomaticAssigment(payload) {  
  try {
    yield put({ type: "GET_STATUS_RECORD_AUTOMATIC_ASIGMENT_REQUESTING" });

    yield put({ type: "SHOW_LOADING" });

    const requestURL = `${process.env.REACT_APP_API_URL}/api/v1/automaticAssigner/assignerstatusRecord?idAddress=${payload.value.idAddress}`;

    const headers = {
      method: "GET",
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
    };

    const response = yield call(request, requestURL, headers);

    yield put({
      type: "HIDE_LOADING",
    });

    yield put({
      type: "GET_STATUS_RECORD_AUTOMATIC_ASIGMENT_SUCCESS",
      value: response,
    });
  } catch (error) {
    yield put({
      type: "SHOW_ALERT",
      value: {
        type: "danger",
        title: "Error",
        message: "Fallo al encontrar los datos",
      },
    });
    yield put({
      type: "HIDE_LOADING",
    });
    yield put({
      type: "GET_STATUS_RECORD_AUTOMATIC_ASIGMENT_ERROR",
    });
  }
}

export function* watchAddressToAutomaticAssigmentSaga() {
  yield takeLatest("GetAutomaticAssignmentRules", getAutomaticAssignmentRules);
  yield takeLatest("GetAllAddressesToAutomaticAssigment", getAllAddressesToAutomaticAssigment);
  yield takeLatest("GetAllFailedAddressesToAutomaticAssigment", getAllFailedAddressesToAutomaticAssigment);
  yield takeLatest("GetAllAddressesToAutomaticAssigmentSocket", getAllAddressesToAutomaticAssigmentSocket);
  yield takeLatest("GetCountAllAddressesToAutomaticAssigment", getCountAllAddressesToAutomaticAssigment);
  yield takeLatest("GetCountAllAddressesToAutomaticAssigmentSocket", getCountAllAddressesToAutomaticAssigmentSocket);
  yield takeLatest("DownloadAllAutomaticAssigment", downloadAllAutomaticAssigment);
  yield takeLatest("DownloadFailedAutomaticAssigment", downloadFailedAutomaticAssigment);
  yield takeLatest("SwitchBotStateAutomaticAssigment", switchBotStateAutomaticAssigment);
  yield takeLatest("GetRecordStatusAutomaticAssigment", getRecordStatusAutomaticAssigment);
  yield takeLatest("GetCountAssignedAdressesByMonth", getCountAssignedAdressesByMonth);
  yield takeLatest("GetAddressesPreviousWeekPieChart", getAddressesPreviousWeekPieChart);
  yield takeLatest("GetDetailToProgressBarToAutomaticAssigment", getDetailToProgressBarToAutomaticAssigment);
}
